module.exports = __webpack_public_path__ + "static/media/whiteclose.194b39d8.svg";